module.exports = __webpack_public_path__ + "static/media/0019.52c4fb87.jpg";